(function () {
  'use strict';

  function getMainProductImage() {
    var selectors = [
      '.comp-product-media img',
      '.vue-media-slider img',
      '[data-vue="root"] img'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var image = document.querySelector(selectors[i]);
      if (image && image.src) return image.src;
    }

    var ogImage = document.querySelector('meta[property="og:image"]');
    return ogImage ? ogImage.getAttribute('content') : '';
  }

  function getProductTitle() {
    var ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle && ogTitle.getAttribute('content')) return ogTitle.getAttribute('content');

    var heading = document.querySelector('.comp-product-details h1');
    return heading ? heading.textContent.trim() : document.title;
  }

  /*
   * Track product-share attempts in GA4 using Google's recommended `share`
   * event. We also publish a Shopify custom customer event so the interaction
   * remains available to Shopify Web Pixels if the analytics implementation
   * changes later.
   */
  function trackProductShare(method) {
    var product = window.parentProduct || {};
    var productId = product.id ? String(product.id) : '';
    var productTitle = product.title || getProductTitle();
    var productHandle = product.handle || '';
    var productUrl = window.location.href.split('#')[0];

    var gaParameters = {
      method: method,
      content_type: 'product',
      item_id: productId,
      product_title: productTitle,
      product_handle: productHandle
    };

    /* Google & YouTube / Google tag installs can expose gtag at runtime. */
    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', 'share', gaParameters);
      } catch (error) {
        /* Sharing must never be blocked by analytics. */
      }
    }

    /* Shopify's supported storefront route for custom customer events. */
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      try {
        var published = Shopify.analytics.publish('marquis_dawe:product_share', {
          method: method,
          content_type: 'product',
          item_id: productId,
          product_title: productTitle,
          product_handle: productHandle,
          product_url: productUrl
        });
        if (published && typeof published.catch === 'function') {
          published.catch(function () {});
        }
      } catch (error) {
        /* Sharing must never be blocked by analytics. */
      }
    }
  }

  function createPinterestLink(href) {
    var link = document.createElement('a');
    link.className = 'md-product-sharing__link md-product-sharing__link--pinterest';
    link.href = href;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.setAttribute('aria-label', 'Save to Pinterest');

    var icon = document.createElement('i');
    icon.className = 'socicon-pinterest';
    icon.setAttribute('aria-hidden', 'true');

    var text = document.createElement('span');
    text.className = 'md-product-sharing__label';
    text.textContent = 'Save to Pinterest';

    link.appendChild(icon);
    link.appendChild(text);
    link.addEventListener('click', function () {
      trackProductShare('Pinterest');
    });
    link.setAttribute('data-md-track-bound', 'true');
    return link;
  }

  function copyProductLink(button, label) {
    var url = window.location.href.split('#')[0];

    function showCopied() {
      var original = label.textContent;
      label.textContent = 'Link copied';
      button.classList.add('is-copied');
      window.setTimeout(function () {
        label.textContent = original;
        button.classList.remove('is-copied');
      }, 1800);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(showCopied).catch(function () {
        window.prompt('Copy this product link:', url);
      });
    } else {
      window.prompt('Copy this product link:', url);
    }
  }

  function createFriendShareButton() {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'md-product-sharing__link md-product-sharing__link--friend';
    button.setAttribute('aria-label', 'Share with a friend');

    var label = document.createElement('span');
    label.className = 'md-product-sharing__label';
    label.textContent = 'Share with a friend';

    button.appendChild(label);

    var arrow = document.createElement('span');
    arrow.className = 'md-product-sharing__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '→';
    button.appendChild(arrow);

    button.addEventListener('click', function () {
      trackProductShare('Share with a friend');

      var shareData = {
        title: getProductTitle(),
        text: 'Thought you might like this from Marquis & Dawe',
        url: window.location.href.split('#')[0]
      };

      /* On supported phones this opens the native share sheet, so customers
         can choose WhatsApp, Messages, Mail, Messenger, etc. */
      if (navigator.share) {
        navigator.share(shareData).catch(function (error) {
          /* Ignore a normal user cancellation; fall back only for real errors. */
          if (error && error.name === 'AbortError') return;
          copyProductLink(button, label);
        });
      } else {
        /* Desktop / older-browser fallback: copy the product URL. */
        copyProductLink(button, label);
      }
    });

    return button;
  }

  function buildSharing() {
    var wrapper = document.createElement('div');
    wrapper.className = 'md-product-sharing';
    wrapper.setAttribute('aria-label', 'Share this product');

    var pageUrl = window.location.href.split('#')[0];
    var imageUrl = getMainProductImage();
    var pinterestUrl = 'https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(pageUrl);
    if (imageUrl) pinterestUrl += '&media=' + encodeURIComponent(imageUrl);

    wrapper.appendChild(createPinterestLink(pinterestUrl));

    var divider = document.createElement('span');
    divider.className = 'md-product-sharing__divider';
    divider.setAttribute('aria-hidden', 'true');
    wrapper.appendChild(divider);

    wrapper.appendChild(createFriendShareButton());
    return wrapper;
  }

  function bindExistingPinterestTracking() {
    var links = document.querySelectorAll('.md-product-sharing__link--pinterest:not([data-md-track-bound])');
    for (var i = 0; i < links.length; i += 1) {
      var link = links[i];
      link.setAttribute('data-md-track-bound', 'true');
      link.addEventListener('click', function () {
        trackProductShare('Pinterest');
      });
    }
  }

  function bindExistingFriendButtons() {
    var buttons = document.querySelectorAll('.md-product-sharing__link--friend:not([data-md-share-bound])');
    for (var i = 0; i < buttons.length; i += 1) {
      var button = buttons[i];
      button.setAttribute('data-md-share-bound', 'true');
      (function (currentButton) {
        currentButton.addEventListener('click', function () {
          trackProductShare('Share with a friend');

          var label = currentButton.querySelector('.md-product-sharing__label');
          var shareData = {
            title: getProductTitle(),
            text: 'Thought you might like this from Marquis & Dawe',
            url: window.location.href.split('#')[0]
          };

          if (navigator.share) {
            navigator.share(shareData).catch(function (error) {
              if (error && error.name === 'AbortError') return;
              copyProductLink(currentButton, label);
            });
          } else {
            copyProductLink(currentButton, label);
          }
        });
      })(button);
    }
  }

  function replaceOldSharing() {
    var oldMenus = document.querySelectorAll('ul.menu-sharing');
    for (var i = 0; i < oldMenus.length; i += 1) {
      var oldMenu = oldMenus[i];
      if (!oldMenu.parentNode) continue;

      /* site.js/Vue creates the old social icon menu at runtime, so replace
         that rendered block rather than relying solely on the Liquid snippet. */
      oldMenu.parentNode.replaceChild(buildSharing(), oldMenu);
    }

    bindExistingPinterestTracking();
    bindExistingFriendButtons();
  }

  function init() {
    replaceOldSharing();

    var observer = new MutationObserver(function () {
      replaceOldSharing();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
